import { repositoryActions } from '../../services';
import deepStrictEqual from 'deep-strict-equal';

export const filterSelectorReducer = group => ( state = {}, action ) => {
  let key = group + '/' + ( action && action.selector ? action.selector.name : '' );

  switch ( action.type ) {
    case repositoryActions( key ).SET:
      return { ...state, [key]: action.filterSelectors };
    case repositoryActions( key ).RETRIEVED:
      let data = JSON.parse( JSON.stringify( action.data ) );

      if ( state[key] && state[key].results && deepStrictEqual( state[key].request, action.data.request ) && (state[key].page !== data.page || state[key].pageSize!== data.pageSize)) {        
        
        let newData = []
        if(data.results && data.results.length>0){
          for(let i=0; i<data.results.length; i++){
            let index = data.page*data.pageSize+i;
            let product = state[key]?.results.find((p)=>p.tableIndex===index);
            if(!product){
              newData.push({...data.results[i], "tableIndex":index});
            }
          }
          data.results = newData;
        }
        data.results.sort((a,b)=>a.tableIndex-b.tableIndex);
        data.results = state[key].results.concat( data.results );
      }

      else if(data.page===0 && data.pageSize===10){
        data.results = data.results && data.results.length>0?data.results.map((prod, key)=>{
          let index = data.page*data.pageSize+key;
          return {...prod, "tableIndex":index};
        }):data.results;
      }

      return { ...state, [key]: data };
    case repositoryActions( key ).CLEAR:
      return { ...state, [key]: null };
    default:
      return state;
  }
};